document.addEventListener('DOMContentLoaded', () => {
	const
	geometriesBG = '.geometry-background',
	geometriesForm = '.container-tabs',
	geometriesTabs = '.tabs-list .active ';
	
	let 
	tl = gsap.timeline();
	
	
	const randomX = random(10, 20);
	const randomY = random(20, 30);
	const randomDelay = random(0, 1);
	const randomTime = random(3, 5);
	const randomTime2 = random(5, 10);
	const randomAngle = random(8, 12);
	let geometriesCollection = document.querySelectorAll(geometriesBG);
	

	function rotate(target, direction) {
		TweenLite.to(target, randomTime2(), {
			rotation: randomAngle(direction),
			ease: Sine.easeInOut,
			onComplete: rotate,
			onCompleteParams: [target, direction * -1]
		});
	}

	function moveX(target, direction) {
  
	  TweenLite.to(target, randomTime(), {
	    x: randomX(direction),
	    ease: Sine.easeInOut,
	    onComplete: moveX,
	    onCompleteParams: [target, direction * -1]
	  });
	}

	function moveY(target, direction) {
  
	  TweenLite.to(target, randomTime(), {
	    y: randomY(direction),
	    ease: Sine.easeInOut,
	    onComplete: moveY,
	    onCompleteParams: [target, direction * -1]
	  });
	}

	function random(min, max) {
	  const delta = max - min;
	  return (direction = 1) => (min + delta * Math.random()) * direction;
	}
	
	
	
	function init() {
		tl.from(geometriesBG, {
			ease: "slow(0.6, 1.2)",
			autoAlpha: 0,
			scale: .1,
			duration: .6,
			opacity: 0,
			stagger: .6,
			onComplete: function() {
				geometriesCollection.forEach(el => {
					moveX(el, 1);
					moveY(el, -1);
					rotate(el, 1);
				});
			}
		}).from(geometriesForm, {
			ease: "slow(0.6, 1.2)",
			autoAlpha: 0,
			scale: .5,
			opacity: 0
		}).from('.tabs-list-active, .tabs-list .active', {
			yPercent: 300
		})
		.from('.tabs-list li:not(.active)', {
			yPercent: 300,
			stagger: .6
		});
	}
	
	window.addEventListener("load", event => {
		init();
	});

});
